<template functional>
  <span
    :aria-hidden="props.decorative"
    :aria-label="props.title"
    :class="[data.class, data.staticClass]"
    class="material-design-icon pencil-outline-icon"
    role="img"
    v-bind="data.attrs"
    v-on="listeners"
  >
    <svg
      :fill="props.fillColor"
      class="material-design-icon__svg"
      :width="props.size"
      :height="props.size"
      viewBox="0 0 15 15"
    >
      <path
        d="M8.51823 2.73147L12.2689 6.48211L4.12451 14.6265L0.780507 14.9956C0.332843 15.0451 -0.0453857 14.6666 0.00441981 14.219L0.376496 10.8726L8.51823 2.73147ZM14.5886 2.17306L12.8276 0.411994C12.2783 -0.137331 11.3873 -0.137331 10.838 0.411994L9.18123 2.06876L12.9319 5.81941L14.5886 4.16264C15.138 3.61302 15.138 2.72238 14.5886 2.17306Z"
        fill="black"
      >
        <title v-if="!props.decorative">{{ props.title }}</title>
      </path>
    </svg>
  </span>
</template>

<script>
export default {
  name: 'PencilOutlineIcon',
  props: {
    title: {
      type: String,
      default: 'Pencil Outline icon'
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: 'currentColor'
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
</script>
